import { _js } from '@ifixit/utils/localize';
import { refusalMessage, webApiClient } from 'Shared/web_api_client';

const copyEndpoints = {
   GuideImage: id => `user/media/images/${id}`,
   GuideVideoObject: id => `user/media/objects/${id}`,
   GuideEmbedObject: id => `user/media/objects/${id}`,
   CartImage: id => `admin/product-images/library/${id}`,
};

class CopyRefused extends Error {}

/** Copies a media item into the library its type belongs to. */
export async function copyToLibrary(id, type) {
   const endpoint = copyEndpoints[type];
   if (!endpoint) {
      throw new CopyRefused(_js('Unable to copy this media type into your Media Library'));
   }
   const client = await webApiClient();
   return client.post(endpoint(id), 'media-copy-to-library');
}

/** Why a copy was refused, or null when it failed some other way. */
export function copyRefusal(error) {
   return error instanceof CopyRefused ? error.message : refusalMessage(error);
}
